
<div id="answer_content">   
    <div class="page_title_content">
        <div class="page_title">{{'QUESTION_ANSWER.TITLE' | translate}}</div>        
    </div>
    
     <div id="question_infos">
        <div id="question_title">{{'QUESTION_ANSWER.QUESTION_TITLE' | translate}} <span id="tester_name">{{this.testerName}}</span></div>
        <div id="question_date">{{'QUESTION_ANSWER.QUESTION_CREATION_DATE' | translate}} {{this.dateCreation | demoozDateToString}}</div>        
    </div>
    
    <div id="question_text">&ldquo; {{this.question.content}} &rdquo;</div>

    <form [formGroup]="this.answerForm" (ngSubmit)="this.confirmSendAnswer()">
        <demooz-textarea label="{{'QUESTION_ANSWER.OUR_ANSWER' | translate}}" formName="answer" [fixedLabel]="true" [showBtnClearInput]="true"/>  
        <demooz-button type="submit" id="button_validate_demo_by_code" label="{{'QUESTION_ANSWER.BUTTON_SEND_ANSWER' | translate}}" [fullSize]="true" [isFetching]="this.isFetchingAnswer"/>      
    </form>
    
</div>